import {useEffect, useState} from 'react';

import {sendDesktopAnalyticsPerSession} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {useInView} from 'react-intersection-observer';

import {CHECKOUT_DELIVERY_STEP} from 'constants/analytics/events/checkout';

/**
 * Hook which send analytic when checkbox appears in view
 */
export const useViewCheckbox = ({
    emailShowed,
    isSubscriptionPhoneEnabled,
    smsShowed,
}: {
    emailShowed: boolean;
    smsShowed: boolean;
    isSubscriptionPhoneEnabled?: boolean | null;
}) => {
    const [isAlreadyShowedEmail, setIsAlreadyShowedEmail] = useState(false);
    const [isAlreadyShowedSms, setIsAlreadyShowedSms] = useState(false);

    const {inView: checkboxInView, ref: checkboxRef} = useInView({
        threshold: 1,
    });
    const {ref: wrapperRef} = useInView({threshold: 1});

    useEffect(() => {
        if (checkboxInView && !isAlreadyShowedEmail) {
            setIsAlreadyShowedEmail(true);
            sendDesktopAnalyticsPerSession({
                event: CHECKOUT_DELIVERY_STEP,
                isInteraction: false,
                label: {message: 'Email Promotion Checkbox - Showed'},
            });
        }
    }, [checkboxInView, isAlreadyShowedEmail, emailShowed]);

    useEffect(() => {
        if (checkboxInView && !isAlreadyShowedSms && isSubscriptionPhoneEnabled) {
            setIsAlreadyShowedSms(true);
            sendDesktopAnalyticsPerSession({
                event: CHECKOUT_DELIVERY_STEP,
                isInteraction: false,
                label: {message: 'SMS Promotion Checkbox - Showed'},
            });
        }
    }, [checkboxInView, isAlreadyShowedSms, smsShowed]);

    return {checkboxRef, wrapperRef};
};
